import { Button } from "primereact/components/button/Button";
import { Calendar } from "primereact/components/calendar/Calendar";
import { Column } from "primereact/components/column/Column";
import { DataTable } from "primereact/components/datatable/DataTable";
import { DataView } from "primereact/components/dataview/DataView";
import { Dialog } from "primereact/components/dialog/Dialog";
import { Dropdown } from "primereact/components/dropdown/Dropdown";
import { Growl } from "primereact/components/growl/Growl";
import { InputText } from "primereact/components/inputtext/InputText";
import { InputTextarea } from "primereact/components/inputtextarea/InputTextarea";
import { Password } from "primereact/components/password/Password";
import { ProgressSpinner } from "primereact/components/progressspinner/ProgressSpinner";
import { ScrollPanel } from "primereact/components/scrollpanel/ScrollPanel";
import { Toolbar } from "primereact/components/toolbar/Toolbar";
import { MegaMenu } from "primereact/components/megamenu/MegaMenu";
import { OverlayPanel } from "primereact/components/overlaypanel/OverlayPanel";
import { Lightbox } from "primereact/components/lightbox/Lightbox";
import { ListBox } from "primereact/components/listbox/ListBox";
import { Sidebar } from "primereact/components/sidebar/Sidebar";
import { SlideMenu } from "primereact/components/slidemenu/SlideMenu";
import { MultiSelect } from "primereact/components/multiselect/MultiSelect";
import { Checkbox } from "primereact/components/checkbox/Checkbox";
import { PickList } from "primereact/components/picklist/PickList";
import { Panel } from "primereact/components/panel/Panel";
import { Accordion } from "primereact/components/accordion/Accordion";
import { AccordionTab } from "primereact/components/accordion/Accordion";
import { Fieldset } from "primereact/components/fieldset/Fieldset";
import { FileUpload } from "primereact/components/fileupload/FileUpload";
import { Messages } from "primereact/components/messages/Messages";
import { Message } from "primereact/components/message/Message";
import { Steps } from "primereact/components/steps/Steps";
import { TabView } from "primereact/components/tabview/TabView";
import { TabPanel } from "primereact/components/tabview/TabView";
import { Editor } from "primereact/components/editor/Editor";
import { InputSwitch } from "primereact/components/inputswitch/InputSwitch";
import { OrganizationChart } from "primereact/components/organizationchart/OrganizationChart";
import { FlowChartWithState } from "@mrblenny/react-flow-chart";
import { TriStateCheckbox } from "primereact/components/tristatecheckbox/TriStateCheckbox";
import { Card } from "primereact/components/card/Card";
import { Spinner } from "primereact/components/spinner/Spinner";
import { Slider } from "primereact/components/slider/Slider";
import { OrderList } from "primereact/components/orderlist/OrderList";
import { BreadCrumb } from "primereact/components/breadcrumb/BreadCrumb";
import { TreeTable } from "primereact/components/treetable/TreeTable";

import React from "react";
import { CrudlStatus } from "../common/config/AppConstants";
export {
  Button,
  Calendar,
  Column,
  DataTable,
  Dialog,
  Dropdown,
  Growl,
  InputText,
  Password,
  ProgressSpinner,
  ScrollPanel,
  InputTextarea,
  Toolbar,
  MegaMenu,
  OverlayPanel,
  Lightbox,
  ListBox,
  Sidebar,
  SlideMenu,
  MultiSelect,
  Checkbox,
  PickList,
  DataView,
  Panel,
  AccordionTab,
  Accordion,
  Fieldset,
  FileUpload,
  Messages,
  Message,
  Steps,
  TabPanel,
  TabView,
  OrganizationChart,
  FlowChartWithState as FlowChart,
  InputSwitch,
  Editor,
  TriStateCheckbox,
  Card,
  BreadCrumb,
  Spinner,
  Slider,
  TreeTable,
  OrderList
};

export const getTableColumn = (name, display) => {
  return {
    field: name,
    header: display,
    sortable: true,
    filter: true,
    filterMatchMode: "contains",
    style: { overflow: "auto" }
  };
};

export const getColumnOptions = columnList => {
  let colOptions = [];
  for (let col of columnList) {
    colOptions.push({ label: col.header, value: col });
  }
  return colOptions;
};

export const getExpanderColumn = () => {
  return (
    <Column
      key="expander"
      expander={true}
      style={{ width: "3em", float: "middle" }}
    />
  );
};

export const getEditDeleteColumn = (
  rowData,
  column,
  editMethod,
  deleteMethod
) => {
  return (
    <div>
      <Button
        icon="pi pi-pencil"
        onClick={() => {
          editMethod(rowData);
        }}
        style={{ float: "middle" }}
      />
      <Button
        icon="pi pi-trash"
        onClick={() => {
          deleteMethod(rowData);
        }}
        style={{ float: "middle" }}
      />
    </div>
  );
};

export const getDropdownOptions = array => {
  let genericArray = [];
  let i = 0;

  if (array !== undefined) {
    array.forEach(e => {
      genericArray[i] = {
        label: e.name,
        value: e.id
      };
      i++;
    });
  }
  console.log(genericArray);
  return genericArray;
};
export const getDropdownOptionsFromList = array => {
  let genericArray = [];
  let i = 0;

  if (array !== undefined) {
    array.forEach(e => {
      genericArray[i] = {
        label: e,
        value: e
      };
      i++;
    });
  }
  console.log(genericArray);
  return genericArray;
};
export const getListOptions = (array, field) => {
  let genericArray = [];
  if (array !== undefined) {
    array.forEach(e => {
      if (e[field]) {
        genericArray.push(e[field]);
      }
    });
  }

  return genericArray;
};
export const getDropdownOptionsExtension = (array, label, value) => {
  let genericArray = [];
  let i = 0;

  if (array !== undefined) {
    array.forEach(e => {
      genericArray[i] = {
        label: e[label],
        value: e[value],
        id: e.id
      };
      i++;
    });
  }

  return genericArray;
};
export const getBreadcrumbMenuState = (crudlStatus, key, keyUrl) => {
  var updatedMenuItems = [];
  if (crudlStatus === CrudlStatus.LIST) {
    updatedMenuItems = [
      { label: key + "s", url: keyUrl },
      { label: "View " + key + "s", url: "" }
    ];
  }
  if (crudlStatus === CrudlStatus.UPDATE) {
    updatedMenuItems = [
      { label: key + "s", url: keyUrl },
      { label: "View " + key + "s", url: "" },
      { label: "Edit " + key, url: "" }
    ];
  }
  if (crudlStatus === CrudlStatus.CREATE) {
    updatedMenuItems = [
      { label: key + "s", url: keyUrl },
      { label: "View " + key + "s", url: "" },
      { label: "Add " + key, url: "" }
    ];
  }
  if (crudlStatus === CrudlStatus.VIEW) {
    updatedMenuItems = [
      { label: key + "s", url: keyUrl },
      { label: "View " + key + "s", url: "" },
      { label: "View " + key, url: "" }
    ];
  }

  return updatedMenuItems;
};

export const getBreadcrumbMenuHome = () => {
  return {
    icon: "pi pi-cog",
    url: "#/"
  };
};



// WEBPACK FOOTER //
// ./src/common/PrimeComponents.js